const menuItems = {
  height: { default: 40 },

  borderRadius: { default: 20 },

  padding: { default: 16 },
}

export default menuItems
